<!--
注意：
此處用於作廢的API(VoidTranInvoice)的對應欄位為：
- foO_CNL_DAT：作廢日期
- foO_CNL_MEM：作廢備註
與一般發票不同，一般發票的 foO_CNL_XXX 為"撤銷"而非"作廢"
--->
<template>
    <div v-if="isVisiable" id="reimbursement-invoice-detail-void-view" class="detail-card red">
        <div class="card-header">
            <div class="title">發票作廢</div>
            <div>
                <el-button v-if="isShowEditButton" style="margin-left: 10px; color: #888" size="mini" @click="onEdit">編輯</el-button>
            </div>
        </div>
        <div class="card-body">
            <!-- 顯示畫面 -->
            <el-row v-if="!isEditing" :gutter="40">
                <el-col :sm="14">
                    <spec-view>
                        <spec-item label="作廢日期">
                            {{ invoice.foO_CNL_DAT | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                        <spec-item label="作廢原因">
                            {{ invoice.foO_CNL_MEM }}
                        </spec-item>
                    </spec-view>
                </el-col>
                <el-col :sm="10">
                    <spec-view>
                        <spec-item label="編輯人">
                            {{ invoice.foO_CNL_CRT_NAM }}
                        </spec-item>
                        <spec-item label="編輯日期">
                            {{ invoice.foO_CNL_CRT_DAT | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                    </spec-view>
                </el-col>
            </el-row>
            <!-- 編輯畫面 -->
            <div v-if="isEditing">
                <el-form :model="editForm" :rules="editRules" ref="editForm" label-position="left" label-width="150px" size="small">
                    <el-form-item prop="">
                        <el-alert
                            v-if="!invoice.declared && this.isAuth('G03') && this.isPayed('G03')"
                            title="注意：確定作廢後，此發票會於營業稅申報中標記為作廢發票"
                            type="warning"
                            :closable="false"
                            style="margin-top: 10px"
                        />
                        <el-alert
                            v-if="invoice.declared && invoice.foO_CNL === 0"
                            type="error"
                            :title="`此發票已申報於 ${getPeriodText(invoice.prefiX_YER, invoice.prefiX_MONTH)} ，不可作廢。`"
                            :closable="false"
                        />
                    </el-form-item>
                    <el-form-item label="發票號碼">
                        <div>{{ invoice.foo }}</div>
                    </el-form-item>
                    <el-form-item prop="foO_CNL_DAT" label="作廢日期">
                        <el-date-picker
                            v-model="editForm.foO_CNL_DAT"
                            value-format="timestamp"
                            type="date"
                            placeholder="請選擇"
                            :picker-options="{ disabledDate }"
                            :disabled="invoice.declared"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="foO_CNL_MEM" :label="`說明原因（必填）`">
                        <el-input v-model.trim="editForm.foO_CNL_MEM" :rows="3" type="textarea" maxlength="200" show-word-limit />
                    </el-form-item>
                    <el-form-item>
                        <template v-if="invoice.foO_CNL">
                            <el-tooltip v-if="invoice.declared" placement="top-start" trigger="hover" content="已申報，無法移除">
                                <el-button type="danger" disabled plain>移除作廢</el-button>
                            </el-tooltip>
                            <el-button v-else @click="onUndo" :loading="isEditLoading" type="danger" plain>移除作廢</el-button>
                        </template>
                        <el-button type="" size="small" :loading="isEditLoading" @click="onEditCancel">取消</el-button>
                        <el-button type="primary" size="small" :loading="isEditLoading" class="primary-action" @click="onEditSubmit">
                            {{ confirmBtnText }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { isBeforeSunPayChangeServerDate } from '@/utils/helpers';
import SpecView from '@/components/ui/SpecView/SpecView.vue';
import SpecItem from '@/components/ui/SpecView/SpecItem.vue';
import { eInvoicePlatformInfo } from '@/assets/commonData/options';

export default {
    props: {
        invoice: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        SpecView,
        SpecItem,
    },
    watch: {
        invoice() {
            this.resetForm();
            this.isEditing = false;
        },
    },
    data() {
        return {
            expend: true,
            isShowFooEditer: false,
            isEditLoading: false,
            isEditing: false,
            invoiceSerialInputValidate: false,
            fooChangeForm: {
                foo: null,
                foO_DAT: null,
            },
            editForm: {
                tioo: null,
                foO_CNL: false,
                foO_CNL_DAT: Number(moment().startOf('day').format('x')),
                foO_CNL_MEM: null,
            },
            editRules: {
                foO_CNL_DAT: [
                    {
                        required: true,
                        message: '請選擇日期',
                        trigger: 'change',
                    },
                ],
                foO_CNL_MEM: [
                    {
                        required: true,
                        message: '請填寫原因（必填）',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    computed: {
        isVisiable() {
            if (this.isEditing) return true;
            if (this.invoice && Object.prototype.hasOwnProperty.call(this.invoice, 'foO_CNL_DAT') && this.invoice.foO_CNL_DAT !== null) {
                return true;
            }
            return false;
        },
        isShowEditButton() {
            if (this.invoice.e_InviceIsCanceled && this.invoice.foO_CNL) return false;
            if (this.isEditing) return false;

            if (this.isAuthOne(['B03'])) {
                return true;
            }
            return false;
        },
        confirmBtnText() {
            return this.editForm.foO_CNL ? '儲存' : '確定作廢';
        },
        isDeleteDateValidate() {
            const CURR_MONTH = moment(this.invoice.foO_DAT).month() + 1;

            let year = moment().year();
            const month = (Math.ceil(CURR_MONTH / 2) * 2 + 1) % 12;
            if (CURR_MONTH > 10) year += 1;

            const DUE_DATE = moment()
                .year(year)
                .month(month - 1)
                .date(15)
                .startOf('day');

            return moment().isBefore(DUE_DATE);
        },
        isDeleteEditable() {
            return this.isDeleteDateValidate;
        },
        isEInvoiceCancelFlow() {
            return (
                this.invoice.e_InvoiceDate
                && !this.invoice.e_InviceIsCanceled
                && this.editForm.foO_CNL
                && this.isEInvoicePlatformMatch
                && !isBeforeSunPayChangeServerDate(this.eInvoicePlatform, this.invoice.e_InvoiceDate)
            );
        },
        isEInvoicePlatformMatch() {
            switch (this.eInvoicePlatform) {
            case 'EZPay':
                return this.invoice.e_InvoicePlatform === 1;
            case 'SunPay':
                return this.invoice.e_InvoicePlatform === 2;
            default:
                return false;
            }
        },
        invoicePlatform() {
            switch (this.invoice.e_InvoicePlatform) {
            case 1:
                return eInvoicePlatformInfo.ezPay;
            case 2:
                return eInvoicePlatformInfo.sunPay;
            default:
                return eInvoicePlatformInfo.none;
            }
        },
        eInvoicePlatform() {
            return this.$store.getters['menu/companyInfo'].eInvoiceInfo?.platform;
        },
    },
    methods: {
        disabledDate(date) {
            if (
                moment(date).isAfter(moment()) // 禁止未來日期
                || moment(date).isBefore(moment(this.invoice?.foO_DAT)) // 禁止發票開立前
            ) {
                return true;
            }
            return false;
        },
        startVoid() {
            this.editForm.foO_CNL = true;
            this.isEditing = true;
        },
        onEdit() {
            this.editForm.tioo = this.invoice.tioo;
            this.editForm.foO_CNL = this.invoice.foO_CNL;
            this.editForm.foO_CNL_DAT = this.invoice.foO_CNL_DAT;
            this.editForm.foO_CNL_MEM = this.invoice.foO_CNL_MEM;
            this.isEditing = true;
            this.scrollToId('reimbursement-invoice-detail-void-view');
        },
        resetForm() {
            this.editForm.tioo = null;
            this.editForm.foO_CNL = false;
            this.editForm.foO_CNL_DAT = Number(moment().startOf('day').format('x'));
            this.editForm.foO_CNL_MEM = null;
        },
        onEditCancel() {
            this.endEdit();
            this.editForm = {
                tioo: null,
                foO_CNL: false,
                foO_CNL_DAT: Number(moment().startOf('day').format('x')),
                foO_CNL_MEM: null,
            };
        },
        onEditSubmit() {
            this.$refs.editForm.validate(async (valid) => {
                if (valid) {
                    try {
                        const confirmText = this.isEInvoiceCancelFlow ? `確認作廢此發票？（此發票將同步作廢${this.invoicePlatform.label}上的電子發票）` : '您確定已作廢當期發票？';

                        await this.$confirm(confirmText, {
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                        });

                        this.submitDiscount();
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        },
        endEdit(needRefresh = false) {
            this.$emit('endEdit', needRefresh);
            this.isEditing = false;
        },

        async submitDiscount() {
            this.isEditLoading = true;
            console.log('submit discount', this.editForm);
            this.editForm.tioo = this.invoice.tioo;

            await this.onUpdateCreditNote();
        },

        async onUpdateCreditNote() {
            try {
                await this.onSubmitVoid();

                this.$message.success('已作廢');
            } finally {
                this.isEditLoading = false;
                this.endEdit(true);
            }
        },
        async onSubmitVoid() {
            if (this.invoice.foO_CNL) {
                await this.$api({
                    url: '/TranInvoice/EditVoidTranInvoice',
                    method: 'post',
                    data: {
                        tioo: this.editForm.tioo,
                        foO_CNL_DAT: this.editForm.foO_CNL_DAT,
                        foO_CNL_MEM: this.editForm.foO_CNL_MEM,
                    },
                });
            } else {
                await this.$api({
                    url: '/TranInvoice/VoidTranInvoice',
                    method: 'post',
                    data: {
                        tioo: this.editForm.tioo,
                        foO_CNL_DAT: this.editForm.foO_CNL_DAT,
                        foO_CNL_MEM: this.editForm.foO_CNL_MEM,
                    },
                });
            }
        },

        async onUndo() {
            try {
                await this.$confirm('確定要刪除作廢', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                this.submitUndo();
            } catch (e) {
                console.log(e);
            }
        },
        async submitUndo() {
            this.isEditLoading = true;
            try {
                if (this.editForm.foO_CNL) {
                    await this.$api({
                        url: '/TranInvoice/DeleteVoidTranInvoice',
                        method: 'DELETE',
                        data: { tioo: this.invoice.tioo },
                    });
                } else {
                    await this.$api({
                        url: '/TranInvoice/DeleteDiscountTranInvoice',
                        method: 'DELETE',
                        data: { tioo: this.invoice.tioo },
                    });
                }
                this.endEdit();
            } finally {
                this.isEditLoading = false;
                this.endEdit(true);
            }
        },
        formatFoo(foo) {
            if (!foo) return '--';
            return `${foo.slice(0, 2)}-${foo.slice(2)}`;
        },
        getPeriodText(year, month) {
            const monthList = ['1~2月', '3~4月', '5~6月', '7~8月', '9~10月', '11~12月'];
            if (year > 1911 && month >= 0 && month < 12) {
                return `${year - 1911}年 ${monthList[month - 1]}`;
            }
            return '';
        },
    },
};
</script>
